import {
    faInfo,
    faNewspaper,
    faPeopleGroup,
    faTicket,
    faReceipt,
    faUser,
} from "@fortawesome/free-solid-svg-icons";

import EditPatient from "../../../components/patient/EditPatient";
import PatientHistory from "../../../components/patient/PatientHistory";
import OverviewSessionsInPatient from "../../../components/patient/OverviewSessionsInPatient";
import OverviewClassesInPatient from "../../../components/patient/OverviewClassesInPatient";
import OverviewAcquiredVoucherInPatient from "../../../components/patient/OverviewAcquiredVoucherInPatient";
import OverviewCashRegistersInPatient from "../../../components/patient/OverviewCashRegistersInPatient";
import ScreenWithTabs from "../../../components/general/auxiliar/ui/ScreenWithTabs";

const PatientDetails = () => {
    const tabs = [
        {
            id: "patient-details",
            name: "Detalles del Paciente",
            smallName: "Detalles",
            icon: faInfo,
            component: <EditPatient />,
        },
        {
            id: "patient-history",
            name: "Historia Clínica",
            smallName: "Historia Clínica",
            icon: faNewspaper,
            component: <PatientHistory />,
        },
        {
            id: "sessions",
            name: "Sesiones Reservadas",
            smallName: "Sesiones",
            icon: faUser,
            component: <OverviewSessionsInPatient />,
        },
        {
            id: "classes",
            name: "Clases Reservadas",
            smallName: "Clases",
            icon: faPeopleGroup,
            component: <OverviewClassesInPatient />,
        },
        {
            id: "vouchers",
            name: "Bonos Adquiridos",
            smallName: "Bonos",
            icon: faTicket,
            component: <OverviewAcquiredVoucherInPatient />,
        },
        {
            id: "cash-registers",
            name: "Albaranes",
            smallName: "Albaranes",
            icon: faReceipt,
            component: <OverviewCashRegistersInPatient />,
        },
    ];

    return <ScreenWithTabs srTitle="Detalles del Paciente" tabs={tabs} />;
};

export default PatientDetails;
